<template>
  <!-- Main 3 column grid -->
  <div class="grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-8">
    <!-- Left column -->
    <div class="grid grid-cols-1 gap-4 lg:col-span-2">

      <div v-if="all_done" class="p-4 text-sm text-green-700 bg-green-100 rounded-lg shadow"
           role="alert">
        <p class="font-medium text-base mb-2">Поздравляем с успешной регистрацией!</p>
        <p>Теперь вы можете выбрать мероприятие на вкладке &laquo;Расписание&raquo; и принять участие</p>
      </div>

      <!-- Welcome panel -->
      <section aria-labelledby="profile-overview-title">
        <div class="rounded-lg bg-white overflow-hidden shadow">
          <div class="bg-white p-6">
            <div class="sm:flex sm:items-center sm:justify-between">
              <div class="sm:flex sm:space-x-5">
                <!--
                <div class="flex-shrink-0">
                  <img class="mx-auto h-20 w-20 rounded-full"
                       :src="this.$store.getters['account/photo']"
                       alt="">
                </div>
                -->
                <span class="inline-flex items-center justify-center h-20 w-20 rounded-full bg-gray-500">
                  <span class="text-3xl font-medium leading-none text-white">{{ user_name[0] }}</span>
                </span>
                <div class="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left">
                  <p class="text-sm font-medium text-gray-600">Добро пожаловать</p>
                  <p class="text-xl font-bold text-gray-900 sm:text-2xl">{{ user_name }}</p>
                  <p class="text-sm font-medium text-gray-600">Куратор</p>
                </div>
              </div>
              <div class="mt-5 flex justify-center sm:mt-0">
                <router-link :to="{name: 'UserProfile', params:{user_id: user_id}}"
                             class="flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                  Открыть профиль
                </router-link>
              </div>
            </div>
          </div>

          <dl class="border-t border-gray-200 mt-5 grid grid-cols-1 overflow-hidden divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
            <div class="px-4 py-5 sm:p-6">
              <dt class="text-base font-normal text-gray-900">Активные заявки</dt>
              <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
                <div class="flex items-baseline text-2xl font-semibold text-primary-600">{{ 0 }}</div>
              </dd>
            </div>
            <div class="px-4 py-5 sm:p-6">
              <dt class="text-base font-normal text-gray-900">Проведенные мероприятия</dt>
              <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
                <div class="flex items-baseline text-2xl font-semibold text-primary-600">{{ 0 }}</div>
                <div class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0">
                  <ui-link :to="{}">Открыть все</ui-link>
                </div>
              </dd>
            </div>
            <div class="px-4 py-5 sm:p-6">
              <dt class="text-base font-normal text-gray-900">Доступные</dt>
              <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
                <div class="flex items-baseline text-2xl font-semibold text-primary-600">{{ 0 }}</div>
                <div class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium md:mt-2 lg:mt-0">
                  <ui-link :to="{name: 'EventsTimetable'}">Открыть все</ui-link>
                </div>
              </dd>
            </div>
          </dl>

        </div>

      </section>

      <div v-if="!my_active " class="relative bg-primary-600 shadow overflow-hidden sm:rounded-md">
        <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
          <div class="pr-16 sm:text-center sm:px-16">
            <p class="font-medium text-white">
              <span class="md:hidden">Нет активных заявок, вам нужно</span>
              <span class="hidden md:inline">Нет активных заявок, для участия вам нужно</span>
              <span class="block sm:ml-2 sm:inline-block">
                <router-link class="text-white font-bold underline" :to="{name: 'EventsTimetable'}">
                  выбрать мероприятие <span aria-hidden="true">&rarr;</span>
                </router-link>
          </span>
            </p>
          </div>
        </div>
      </div>

      <div v-else class="bg-white shadow overflow-hidden sm:rounded-md">
        <ul role="list" class="divide-y divide-gray-200">
          <li v-for="request in my_active" :key="request.id">
            <router-link :to="{name:'UserEvent', params: {id: request.id}}" class="block hover:bg-gray-50">
              <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                  <p class="text-sm font-medium text-primary-600 truncate">
                    {{ request.event.name }}
                  </p>
                  <div class="ml-2 flex-shrink-0 flex">
                    <p class="px-2 inline-flex text-xs leading-5 font-semibold">
                      <ui-badge v-if="request.status === 'open'">Создается</ui-badge>
                      <ui-badge v-if="request.status === 'payed'" color="green">Оплачено</ui-badge>
                    </p>

                  </div>
                </div>
                <div class="mt-2 sm:flex sm:justify-between">
                  <div class="sm:flex">
                    <p class="flex items-center text-sm text-gray-500">
                      <UsersIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>
                      {{ request.members.length }}
                    </p>
                    <p class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">

                    </p>
                  </div>
                  <div class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0">
                    <CalendarIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true"/>
                    <p>
                      До
                      <time :datetime="request.event.ended_at">{{ request.event.ended_at }}</time>
                    </p>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="bg-white shadow overflow-hidden sm:rounded-md p-6">
<!--        <td class="block2_c">
          <div>
            <p style="text-align: justify">
              <strong style="color: rgb(51, 102, 153); font-size: 16px;">Важно!&nbsp;</strong><span
                style="color: rgb(0, 0, 0);"><span style="font-size:16px;">Уважаемые координаторы! Просим Вас тщательно проверять данные участников, которые Вы вносите в заявку. Данные для дипломов, сертификатов, благодарностей программа берет из Ваших заявок! Не регистрируйте, пожалуйста, детей в качестве кураторов и координаторов! </span><span
                style="font-size: 16px;">Неоплаченные заявки можно удалить!&nbsp;</span></span><span
                style="color: rgb(0, 0, 0); font-size: 16px;">Ответы на вопросы по оформлению заявки и оплате оргвзносов Вы найдете в&nbsp; разделе "Помощь" на сайте.</span>
            </p>
          </div>
          <div style="text-align: justify">
            <span style="color:#000;"><span style="color:#336699;"><span style="font-size:16px;"><b>Как принять участие в мероприятии:</b></span></span><span
                style="font-size: 20px;">&nbsp;</span></span></div>
          <div style="text-align: justify">
            <div style="text-align: justify; ">
		<span style="color:#000;"><font class="Apple-style-span" size="4"><span class="Apple-style-span"
                                                                            style="font-size: 14px;"><br>
		</span></font></span></div>
            <div style="text-align: justify; ">
		<span style="color:#000;"><span style="font-size:16px;"><font class="Apple-style-span"><span
        class="Apple-style-span"><strong>1.&nbsp;</strong>Зарегистрировать личный кабинет на сайте&nbsp;&nbsp;<u>www.unikru.ru</u>, если у Вас его еще нет.<br>
		<strong>2.</strong>&nbsp;Подать заявку через личный кабинет и добавить в нее участника (-ов) <span
          style="color:#336699;"><strong>в срок регистрации</strong></span> на мероприятие.<br>
		<strong>3.</strong>&nbsp;Оплатить оргвзнос <span style="color:#336699;"><strong>в срок регистрации</strong></span> на мероприятие.</span></font></span></span>
            </div>
            <div style="text-align: justify; ">
              <span style="color:#000;"><span style="font-size:16px;"><span class="Apple-style-span"><strong>4.</strong>&nbsp;Скачать и выполнить задание <span
                  style="color:#336699;"><strong>в срок проведения</strong></span> мероприятия.</span></span></span>
            </div>
            <div style="text-align: justify; ">
              <span style="color:#000;"><span style="font-size:16px;"><span class="Apple-style-span"><strong>5.</strong>&nbsp;Загрузить файл с выполненными заданиями через личный кабинет <span
                  style="color:#336699;"><strong>в срок проведения</strong></span> мероприятия.&nbsp;</span></span></span><span
                style="color: rgb(51, 102, 153); font-size: 16px;">Для внесения ответов выберите слева раздел "Мероприятия", зайдите в Вашу заявку и нажмите на ссылку "Ответить" напротив ФИО участника</span>
            </div>
            <div style="text-align: justify; ">
		<span style="color:#000;"><span style="font-size:16px;"><font class="Apple-style-span"><br>
		</font></span></span></div>
            <div style="text-align: justify; ">
              <span style="color:#336699;"><strong><font class="Apple-style-span" size="4"><span
                  class="Apple-style-span" style="font-size: 14px;"><span style="font-size: 14px; "><span
                  style="font-size:16px;">Обязательно ознакомьтесь с разделом "Помощь" на нашем сайте!</span></span></span></font></strong></span>
            </div>
            <div style="text-align: justify; ">
              &nbsp;
            </div>
            <div style="text-align: justify; ">
              <span style="color:#008080;"><u style="box-sizing: border-box;"><span
                  style="box-sizing: border-box; font-size: 16px;"><span
                  style="box-sizing: border-box; font-weight: bolder; line-height: 27px;"><span
                  style="box-sizing: border-box;">Расписание мероприятий на <span style="color:#ff8c00;">1</span> полугодие <span
                  style="color:#ff8c00;">2022-2023</span> учебного года </span></span></span></u><u
                  style="box-sizing: border-box;"><span style="box-sizing: border-box; font-size: 16px;"><span
                  style="box-sizing: border-box; font-weight: bolder; line-height: 27px;"><span
                  style="box-sizing: border-box;">(скоро будет опубликовано).</span></span></span></u></span></div>
            <div style="text-align: justify; ">
              <span style="box-sizing: border-box; font-size: 16px;"><span
                  style="box-sizing: border-box; color: rgb(51, 102, 153);">Уважаемые координаторы! При оплате на кошелек ЮMoney необходимо отправить копию (фото) чека на электронный адрес</span><span
                  style="box-sizing: border-box;">&nbsp;</span></span><span
                style="box-sizing: border-box; font-size: 16px; color: rgb(255, 140, 0);"><span
                style="box-sizing: border-box; font-weight: bolder;">mir-konkursov2008@yandex.ru</span><span
                style="box-sizing: border-box; color: rgb(0, 0, 205);">,</span>&nbsp;</span><span
                style="box-sizing: border-box; font-size: 16px; color: rgb(51, 102, 153);">указав название конкурса и ФИО координатора.</span>
            </div>
            <div style="text-align: justify; ">
              &nbsp;
            </div>
            <div style="text-align: justify; ">
              <strong
                  style="line-height: 22.5px; font-size: 15px; color: rgb(0, 0, 0); font-family: arial, sans-serif;"><span
                  style="color: rgb(51, 102, 153); font-size: 16px; line-height: 21.5333px;">При оформлении и оплате заявок на олимпиады и конкурсы до 20 сентября 2022 (включительно) оргвзнос за одного участника составляет 30 рублей при оплате через электронные деньги ЮMoney и 40 рублей при оплате через кнопку "банк-онлайн" на сайте.</span></strong>
            </div>
            <div style="text-align: justify; ">
              &nbsp;
            </div>
            <div style="text-align: justify; ">
              <span style="color: rgb(0, 0, 0); font-size: 16px;">Для участников из стран СНГ (Казахстан, Беларусь, Молдова и т.д.) оплата через банк не принимается, только через электронные деньги. Наградной материал (дипломы, сертификаты, благодарности) предоставляется только в электронном виде!</span>
            </div>
            <div style="text-align: justify; ">
              &nbsp;
            </div>
            <div style="text-align: justify; ">
              <strong style="color: rgb(0, 128, 128); font-family: Arial, Helvetica, sans-serif; font-size: 16px;"><span
                  style="font-family: Arial, sans-serif;">Реквизиты ООО "Мир конкурсов"</span></strong><br>
              <div
                  style="box-sizing: border-box; font-size: 16px; line-height: 24px; color: rgb(0, 0, 0); font-family: Arial, Helvetica, sans-serif;">
                <span style="box-sizing: border-box;">ИНН 2452038035, КПП 245201001</span></div>
              <div
                  style="box-sizing: border-box; font-size: 16px; line-height: 24px; color: rgb(0, 0, 0); font-family: Arial, Helvetica, sans-serif;">
                <span style="box-sizing: border-box;">ОГРН 1102452000584</span></div>
              <div
                  style="box-sizing: border-box; font-size: 16px; line-height: 24px; color: rgb(0, 0, 0); font-family: Arial, Helvetica, sans-serif;">
			<span style="box-sizing: border-box;"><br style="box-sizing: border-box;">
			</span></div>
              <div
                  style="box-sizing: border-box; font-size: 16px; line-height: 24px; color: rgb(0, 0, 0); font-family: Arial, Helvetica, sans-serif;">
                <div style="box-sizing: border-box;">
                  <span style="box-sizing: border-box;">Расчетный счет № 40702810402070001548</span></div>
                <div style="box-sizing: border-box;">
                  <span style="box-sizing: border-box;">Ф-Л СИБИРСКИЙ ПАО БАНК "ФК ОТКРЫТИЕ"</span></div>
                <div style="box-sizing: border-box;">
                  <span
                      style="box-sizing: border-box;">Адрес:&nbsp;630091, Новосибирская область, город Новосибирск,</span>
                </div>
                <div style="box-sizing: border-box;">
                  <span style="box-sizing: border-box;">улица Державина, дом&nbsp;14</span></div>
                <div style="box-sizing: border-box;">
                  <span style="box-sizing: border-box;">БИК 045004867</span></div>
                <span style="box-sizing: border-box;">Корр. счет № 30101810250040000867</span></div>
            </div>
          </div>
          <div style="text-align: justify">
            <div>
		<span style="color:#000;"><br>
		</span></div>
            <div>
              <div style="color: rgb(0, 0, 0); font-family: Arial, Helvetica, sans-serif; ">
                <div>
                  <span style="color:#000;"><span style="font-size:16px;"><span style="color:#008080;"><strong><span
                      style="font-family: Arial, sans-serif;">Центр интеллектуальных и творческих состязаний «Мир конкурсов» и «Уникум»&nbsp;</span></strong></span><span
                      style="font-family: Arial, sans-serif;"><a href="http://www.unikru.ru/userfiles/Svid_gos_reg.jpg">имеет государственную регистрацию</a>&nbsp;и внесен в реестр юридических лиц РФ в соответствии с требованиями законодательства. Номер свидетельства налогоплательщика&nbsp;</span><span
                      style="font-size:18px;"><strong style="font-size: 14px; text-align: -webkit-right;">24 № 005087584, </strong></span></span><span
                      style="font-family: Arial, sans-serif; font-size: 12pt;">образовательная лицензия</span><span
                      class="apple-converted-space"
                      style="font-family: Arial, sans-serif; font-size: 12pt;">&nbsp;</span><strong
                      style="color: teal; font-family: Arial, sans-serif; font-size: 12pt;">8162-л от 07 сентября 2015 года</strong><span
                      style="font-family: Arial, sans-serif; font-size: 16px;">.</span></span></div>
                <div>
				<span style="color:#000;"><br>
				</span></div>
                <div>
                  <span style="color:#000;"><strong style="color: rgb(0, 128, 128); font-size: 16px;">Роспатент зарегистрировал товарный знак МИР КОНКУРСОВ</strong><span
                      style="font-size: 16px;">. Правообладателем этого товарного знака является ООО "Мир конкурсов" (</span><a
                      href="http://www.unikru.ru/userfiles/Svid_tovar_Znak(1).jpg" style="font-size: 16px;">Свидетельство №453251</a><span
                      style="font-size: 16px;">).</span></span></div>
              </div>
            </div>
          </div>
        </td>-->
      </div>

    </div>

    <!-- Right column -->
    <div class="grid grid-cols-1 gap-4">
      <announcement-col/>

    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import AnnouncementCol from "@/views/announcements/AnnouncementCol";
import UiLink from "@/components/ui/UiLink";
import {CalendarIcon, UsersIcon} from "@heroicons/vue/solid"
import UiBadge from "@/components/ui/elements/badges/UiBadge";

export default {
  components: {UiBadge, UiLink, AnnouncementCol, CalendarIcon, UsersIcon},
  setup() {
    return {
      events: []
    }
  },
  data: () => ({
    open: false,
    //open: false,
  }),
  methods: {
    ...mapActions('alerts', {pushAlert: 'add'}),

    clickOutside() {
      //console.log(e)
    },
    push() {
      this.$api.auth.check()
      //this.pushAlert({text: 'Тестовый алерт', title: 'Критическая ошибка'})
    }
  },
  computed: {
    ...mapGetters('account', {user_id: 'id', 'user_name': 'name'}),
    ...mapGetters('user_events', ['my_active']),
    all_done() {
      return this.$route.query.all_done === 'true'
    }
  },
  mounted() {
    this.$store.dispatch('user_events/loadMyActive')
  }
}
</script>


<!--
<script>
export default {
  name: 'Home',
  components: {}
}
</script>
-->
